import { clipTextEllipsis } from './textEllipsis';

const shippingDetailsSchema = (
  deliveryTime,
  deliveryTimeUnit,
  deliveryCost,
  deliveryCurrency,
  addressCountry = process.env.REACT_APP_COUNTRY_CODE
) => {
  if (!deliveryTime || deliveryCost === undefined) return {};

  return {
    shippingDetails: {
      '@type': 'OfferShippingDetails',
      deliveryTime: {
        '@type': 'ShippingDeliveryTime',
        transitTime: {
          '@type': 'QuantitativeValue',
          value: deliveryTime,
          unitText: deliveryTimeUnit,
        },
      },
      shippingRate: {
        '@type': 'MonetaryAmount',
        value: deliveryCost,
        currency: deliveryCurrency,
      },
      shippingDestination: {
        '@context': 'https://schema.org',
        '@type': 'DefinedRegion',
        addressCountry,
      },
    },
  };
};

const addValidProperty = (prop, value) => (value ? { [prop]: value } : {});

const brandSchema = (brandName) =>
  brandName
    ? {
        brand: {
          '@type': 'Brand',
          name: brandName,
        },
      }
    : {};

const reviewsSchema = (reviews, anonymousName) =>
  reviews?.length
    ? {
        reviews: reviews.map((review) => ({
          '@type': 'Review',
          reviewBody: review.text,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: review.rating,
          },
          author: {
            '@type': 'Person',
            name: review.visitor?.name || anonymousName,
          },
        })),
      }
    : {};

const ratingSchema = (rating) =>
  rating?.number_of_ratings > 0
    ? {
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingCount: rating.number_of_ratings,
          ratingValue: rating.total_rating,
        },
      }
    : {};

const hasAdultConsideration = (adult) => (adult ? { hasAdultConsideration: 'SexualContentConsideration' } : {});

const availability = (expiredProduct) => ({
  availability: !!expiredProduct ? 'https://schema.org/OutOfStock' : 'https://schema.org/InStock',
});

export const productSchema = (
  name,
  description,
  sku,
  brandName,
  gtin13,
  image,
  reviews,
  anonymousName,
  rating,
  adult,
  offers,
  expiredProduct,
  campaign
) => {
  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: clipTextEllipsis(name, 150),
    ...brandSchema(brandName),
    ...addValidProperty('description', description),
    ...addValidProperty('gtin13', gtin13),
    sku,
    ...addValidProperty('image', image),
    ...reviewsSchema(reviews, anonymousName),
    ...ratingSchema(rating),
    ...hasAdultConsideration(adult),
    offers: offers.map((offer) => {
      return {
        '@type': 'Offer',
        priceCurrency: process.env.REACT_APP_WEBSITE_CURRENCY,
        price: parseFloat(offer.price),
        ...addValidProperty('itemCondition', 'https://schema.org/NewCondition'),
        ...availability(expiredProduct),
        seller: {
          '@type': 'Organization',
          name: offer.name || campaign,
        },
        ...shippingDetailsSchema(
          offer.structuredDeliveryTime?.value,
          offer.structuredDeliveryTime?.unit,
          offer.deliveryCosts,
          offer.currency
        ),
      };
    }),
  };
};
